<!-- 每周果情 -->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <infoPageList-02 :showTitle="true" :showOrder="false" title="行情分析" label="INFORMARION" :showMore="false" :infoPage="infoPage" :infoBlock="pageInfoBlock"  :tabList="tabList" :tabDefaultType="tabDefaultType" tabClass="list-tab-ul-1" count="20" v-on:queryPage="hqfx_Req" v-on:clickTab="chooseTab"/>
      </div>
<!--      <div class="content-col col-per-30">-->
<!--        <infoList title="精选排行" label="INFORMARION" :showTitle="true" :showMore="false" :infoBlock="infoBlock3" :infoPage="infoPage3" v-on:queryPage="jxph_Req" titleLength="18" count="8"/>-->
<!--        <infoList title="每周果情" label="INFORMARION" :showTitle="true" :showMore="false" :infoBlock="infoBlock3" :infoPage="infoPage4" v-on:queryPage="mzgq_Req" titleLength="18" count="8"/>-->
<!--      </div>-->
    </div>
  </div>
</div>
</template>

<script>
import InfoPageList02 from '../block/InfoPageList02'
import JghqInfo2 from '../module/JghqInfo2'
import SgqgInfo from '../module/SgqgInfo'
import InfoList04 from '../block/InfoList04'
import TitleInfoBlock01 from '../block/TitleInfoBlock01'
export default {
  name: 'Sghq02',
  components: {
    'infoPageList-02': InfoPageList02,
    'infoList-04': InfoList04
  },
  data () {
    return {
      msg: '',
      pageInfoBlock: JghqInfo2,
      infoPage: {},
      tabList: [{title: '市场行情', type: 'market_quotations'}, {title: '每周果情', type: 'weekly_quotations'}],
      tabDefaultType: 'weekly_quotations',
      infoBlock3: TitleInfoBlock01,
      infoPage3: {},
      infoPage4: {}
    }
  },
  methods: {
    chooseTab: function (tabType) {
      // this.selectedItem=clickedItem.title
      this.tabDefaultType = tabType
      this.hqfx_Req({pageSize: 7, page: 1, type: tabType, objectId: 930})
    },
    // 行情分析、每周果情
    hqfx_Req (params) {
      let that = this
      let result = {page: params}
      console.log(params.title + '开始请求Vue-axios,参数：' + JSON.stringify(params))
      that.$dataApi.articleList(params).then(res => {
        // console.log('请求Vue-axios结果：'+JSON.stringify(res))
        that.msg = res.msg
        result.list = res.data.list
        result.page.total = res.data.total
        that.infoPage = result
        // console.log('结束请求Vue-axios：'+JSON.stringify(result))
      })
    },
    // 精选排行
    jxph_Req (params) {
      let that = this
      params.type = 'policy_analysis'
      let result = {page: params}
      // console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
      that.$dataApi.articleList(params).then(res => {
        // console.log('请求Vue-axios结果：'+JSON.stringify(res))
        that.msg = res.msg
        result.list = res.data.list
        result.page.total = res.data.total
        that.infoPage3 = result
        // console.log('结束请求Vue-axios：'+JSON.stringify(result))
      })
    },
    // 每周果情
    mzgq_Req (params) {
      let that = this
      params.type = 'weekly_quotations'
      let result = {page: params}
      // console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
      that.$dataApi.articleList(params).then(res => {
        // console.log('请求Vue-axios结果：'+JSON.stringify(res))
        that.msg = res.msg
        result.list = res.data.list
        result.page.total = res.data.total
        that.infoPage4 = result
        // console.log('结束请求Vue-axios：'+JSON.stringify(result))
      })
    }

  },
  created: function () {
    let params = {page: 1, pageSize: 7, type: this.tabDefaultType, objectId: 930}
    console.log('水果行情开始请求：' + JSON.stringify(params))
    this.hqfx_Req(params)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Sghq02.vue